<h1 matDialogTitle>{{ 'Manage SED Password' | translate }}</h1>
<form class="ix-form-container" (submit)="onSubmit($event)">
  <ix-input
    type="password"
    [formControl]="passwordControl"
    [label]="'SED Password' | translate"
    [tooltip]="helptext.disk_form_passwd_tooltip | translate"
  ></ix-input>

  <ix-form-actions>
    <button
      *ixRequiresRoles="requiredRoles"
      mat-button
      type="submit"
      color="primary"
      ixTest="save"
      [disabled]="passwordControl.invalid"
    >
      {{ 'Save' | translate }}
    </button>
    <button
      *ngIf="disk?.passwd"
      mat-button
      type="button"
      ixTest="clear-sed-password"
      (click)="onClearPassword()"
    >
      {{ 'Clear SED Password' | translate }}
    </button>
    <button mat-button type="button" ixTest="cancel" [matDialogClose]="false">
      {{ 'Cancel' | translate }}
    </button>
  </ix-form-actions>
</form>
